module.exports = __webpack_public_path__ + "media/images/components/map-icons/contacts-map-pin-party_director-283b3d76dcde0cf2477d9b74e7fe1037.png";